module.exports = __webpack_public_path__ + "static/media/Scott Mueller Headshot.e0a8843c.jpeg";